import React, { useContext } from "react"
import { Link } from "gatsby"

// Styles
import "./Bubble.scss"

// Component
import { StateContext } from "../../../StateProvider"

// IMG
import close from "../../../images/card_icons/close.svg"

const Bubble = ({ articleArr }) => {
  const [state, setState] = useContext(StateContext)

  return (
    <div className="bubble-wrapper">
      <div className="cart-overflow">
        <ul>
          <li>
            <p>Ihre Liste:</p>
          </li>
          {articleArr && articleArr.length === 0 ? (
            <li className="empty-list">
              <p>Keine Attraktionen</p>
            </li>
          ) : (
            articleArr &&
            articleArr.map(item => {
              // Click function
              const handleClick = () => {
                let newArray = [...state]
                newArray[item.id] = {
                  ...newArray[item.id],
                  state: !newArray[item.id].state,
                }
                setState([...newArray])
              }
              return (
                <li key={item.id}>
                  <p>{item.title}</p>
                  <div className="close-btn" onClick={handleClick}>
                    <img src={close} alt="close" />
                  </div>
                </li>
              )
            })
          )}
        </ul>
      </div>
      {articleArr && articleArr.length === 0 ? null : (
        <Link className="check-btn btn" to="/formular">
          Zum Buchungsantrag
        </Link>
      )}
    </div>
  )
}

export default Bubble
